import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/auth";

// Ces données vivaient dans le localStorage : elles disparaissaient au changement
// d'appareil et n'appartenaient à personne. Elles sont désormais rattachées au compte.

export function useGoals() {
  const [state, setState] = useState({ goals: [], completed: 0, total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setError(false);
    return api.get("/me/goals")
      .then(r => setState(r.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const add = useCallback(async title => { await api.post("/me/goals", { title }); return load(); }, [load]);
  const toggle = useCallback(async goal => { await api.patch(`/me/goals/${goal.id}`, { done: !goal.done }); return load(); }, [load]);
  const remove = useCallback(async id => { await api.delete(`/me/goals/${id}`); return load(); }, [load]);

  return { ...state, loading, error, reload: load, add, toggle, remove };
}

export function useFavorites(kind) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get(`/me/favorites/${kind}`)
      .then(r => { if (!cancelled) setItems(r.data.items); })
      .catch(() => { if (!cancelled) setItems([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [kind]);

  const toggle = useCallback(async id => {
    const r = await api.put(`/me/favorites/${kind}`, { item_id: id });
    setItems(r.data.items);
    return r.data.saved;
  }, [kind]);

  return [items, toggle, loading];
}

